<div class="container">
  <div class="loading-icon" *ngIf="showSpinner"></div>
  <button type="button" [class]="className" [class.hide]="showSpinner" [class.disabled]="disabled" (click)="onClickButton($event)">{{label}} </button>
</div>